// Styles
import './language.css';

import {
	useEffect,
	useState,
} from 'react';

import {
	useDispatch,
	useSelector,
} from 'react-redux';
// React
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
// Redux
import { Dispatch } from 'redux';

import { setLanguage } from '../../actions/user';
// Utils
import { trads as allTrads } from '../../datas/trads';
import kaatsbaanBg from '../../style/assets/kaatsbaan/background.jpg';
import kapelBg from '../../style/assets/kapel/background.jpg';
import nlFlag from '../../style/assets/language/flags/du.png';
import enFlag from '../../style/assets/language/flags/en.png';
import frFlag from '../../style/assets/language/flags/fr.png';
import deFlag from '../../style/assets/language/flags/ge.png';
import molenBg from '../../style/assets/moulin/background.jpg';
import touwslagerijBg from '../../style/assets/cordier/background.jpg';
import vissersBg from '../../style/assets/vissers/background.jpg';

export const Language = (props: any) => {
	const language: string = useSelector((state: any) => state.user.language);
	const navigate = useNavigate();
	const dispatch: Dispatch<any> = useDispatch();

	const [background, setBackground] = useState(touwslagerijBg);
	const [menuLang, displayMenuLang] = useState(false);

	const goNext = () => {
		if (props.next) {
			props.next();
		}

		let languageElem = document.getElementById('language');
		if (languageElem) {
			languageElem.style.opacity = '0';
		}
	};

	const changeLang = (lang: string) => {
		console.log('↳ Change lang: ', lang);
		dispatch(setLanguage(lang));
	};

	useEffect(() => {
		switch (props.place) {
			case 'touwslagerij':
				setBackground(touwslagerijBg);
				break;
			case 'kaatsbaan':
				setBackground(kaatsbaanBg);
				break;
			case 'kapel':
				setBackground(kapelBg);
				break;
			case 'molen':
				setBackground(molenBg);
				break;
			case 'vissers':
				setBackground(vissersBg);
				break;
		}
	}, []);

	// @ts-ignore
	let trads = allTrads[language];

	const options = [
		{ value: 'nl', label: 'Nederlands', image: nlFlag },
		{ value: 'fr', label: 'Français', image: frFlag },
		{ value: 'de', label: 'Deutsch', image: deFlag },
		{ value: 'en', label: 'English', image: enFlag },
	];

	return (
		<div
			id='language'
			className='language'
			style={{
				backgroundImage: `url(${background})`,
			}}
		>
			<div className='language-container'>
				<div className='language-part language-title '>
					<div className='language-titleLine'>{trads.languagePage.header1}</div>
					<div className='language-titleLine'>{trads.languagePage.header2}</div>
				</div>
				<div className='language-part language-enterButton '>
					<div className='language-enter clickable ' onClick={(e) => goNext()}>
						<div style={{margin: "6px", transform: "translateY(6%)"}}>ENTER</div>
					</div>
				</div>
				<div className='language-part language-langSelectionContainer '>
					<Select
						id={'language-langSelection'}
						className={'language-langSelection'}
						classNamePrefix={'language-langSelection'}
						defaultValue={options[0]}
						value={options.filter((e) => e.value === language)[0]}
						options={options}
						isSearchable={false}
						formatOptionLabel={(country) => (
							<div className={'language-langOption'}>
								<div
									className='language-langFlag'
									style={{
										backgroundImage: 'url(' + country.image + ')',
										backgroundSize: 'cover',
										backgroundRepeat: 'no-repeat',
										backgroundPosition: 'center',
									}}
								></div>
								<div className={'language-langLang'}>{country.label}</div>
							</div>
						)}
						onChange={(e) => {
							if (e) {
								changeLang(e.value);
							}
						}}
						menuPlacement={'auto'}
					/>
				</div>
			</div>
		</div>
	);
};
